import {
  Autocomplete,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  MenuItem,
  Popover,
  Stack,
  TextField,
} from "@mui/material";
import { enqueueSnackbar, SnackbarProvider } from "notistack";
import React, { useEffect, useState } from "react";
import { API_URL } from "../../helpers/variables";
import { useLoaderData } from "react-router-dom";

const Tools = () => {
  const { PMSList } = useLoaderData();

  const DEFAULT_SEARCH_FORM = {
    pms: "",
    corporation: null,
    reportDate: null,
  };

  const [PMSCorporations, setPMSCorporations] = useState([]);
  const [openSearch, setOpenSearch] = useState(false);
  const [backdropLoading, setBackdropLoading] = useState(false);
  const [searchSaleForm, setSearchSaleForm] = useState(DEFAULT_SEARCH_FORM);

  useEffect(() => {
    if (searchSaleForm.pms !== "") getPMSCorporations();
  }, [searchSaleForm.pms]);

  async function getPMSCorporations() {
    let res = await fetch(
      `${API_URL}/pms_corporations?pms=${searchSaleForm.pms}`
    );
    setPMSCorporations(await res.json());
  }

  const closeSearch = () => {
    setOpenSearch(false);
    setSearchSaleForm(DEFAULT_SEARCH_FORM);
  };

  async function searchSale() {
    let { corporation, reportDate } = searchSaleForm;
    let [yyyy, mm, dd] = reportDate.split("-");

    setBackdropLoading(true);
    let res = await fetch(
      `${API_URL}/get_sale_details?corporation_id=${
        corporation["id"]
      }&report_date=${encodeURIComponent(`${mm}/${dd}/${yyyy}`)}`
    );
    setBackdropLoading(false);
    if (res.status !== 200) {
      enqueueSnackbar(await res.text());
    } else {
      let { _id, status } = await res.json();
      if (status === 0) {
        enqueueSnackbar("The searched sale is currently on hold.");
      } else {
        let receivedDate = objectIdToDate(_id);
        alert(`The searched sale was found on ${receivedDate}`);
      }
    }
  }

  return (
    <Box p={3}>
      <SnackbarProvider />
      <TextField
        select
        value={searchSaleForm.pms}
        onChange={(e) =>
          setSearchSaleForm((prev) => ({ ...prev, pms: e.target.value }))
        }
        sx={{ minWidth: 250 }}
        size="small"
        label="PMS"
      >
        {PMSList.map((item, index) => (
          <MenuItem key={index} value={item}>
            {item}
          </MenuItem>
        ))}
      </TextField>

      <Button
        onClick={(e) => setOpenSearch(e.target)}
        disabled={!searchSaleForm.pms}
        variant="contained"
      >
        Search sale
      </Button>

      <Popover
        open={Boolean(openSearch)}
        anchorEl={openSearch}
        onClose={closeSearch}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Stack gap={2} p={1}>
          <Autocomplete
            size="small"
            sx={{ minWidth: 300 }}
            value={searchSaleForm.corporation}
            onChange={(_, corporation) =>
              setSearchSaleForm((p) => ({ ...p, corporation }))
            }
            options={PMSCorporations}
            getOptionLabel={(o) => o.pcName || o.name}
            getOptionKey={(o) => o._id}
            renderInput={(params) => (
              <TextField {...params} label="Corporation or PC" />
            )}
          />
          <TextField
            value={searchSaleForm.reportDate}
            onChange={(e) =>
              setSearchSaleForm((p) => ({ ...p, reportDate: e.target.value }))
            }
            type="date"
            size="small"
            label="Sale date"
            slotProps={{ inputLabel: { shrink: true } }}
          />
          <Button
            disabled={!searchSaleForm.corporation || !searchSaleForm.reportDate}
            onClick={searchSale}
          >
            Search
          </Button>
        </Stack>
      </Popover>

      <Backdrop
        open={backdropLoading}
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.snackbar + 1 })}
      >
        <CircularProgress />
      </Backdrop>
    </Box>
  );
};

export default Tools;

function objectIdToDate(objectId) {
  if (!objectId) return null;
  const timestamp = parseInt(objectId.substring(0, 8), 16);
  return new Date(timestamp * 1000);
}
